module.exports = __webpack_public_path__ + "static/media/menu-closed.2d511a83.svg";